import React from 'react';
import { Brain, HeartPulse, Shield, Wallet } from 'lucide-react';
import { motion } from 'framer-motion';
const niches = [{
  icon: Brain,
  title: 'Estoicismo',
  description: 'Filosofía práctica para la vida moderna. Citas, reflexiones y sabiduría atemporal.',
  delay: 0
}, {
  icon: HeartPulse,
  title: 'Curiosidades Médicas',
  description: 'Datos sorprendentes del cuerpo humano y salud explicados de forma sencilla.',
  delay: 0.1
}, {
  icon: Shield,
  title: 'Relatos de Crimen',
  description: 'Historias de misterio y casos reales narrados con respeto y suspenso.',
  delay: 0.2
}, {
  icon: Wallet,
  title: 'Finanzas para el Hogar',
  description: 'Tips de ahorro, presupuesto y economía doméstica para familias reales.',
  delay: 0.3
}];
export function NicheGrid() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-160">
      {niches.map((niche, index) => <motion.div key={index} initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: niche.delay,
      duration: 0.5
    }} whileHover={{
      y: -5,
      boxShadow: '0 10px 30px -10px rgba(212, 168, 67, 0.3)'
    }} className="bg-[#243352]/40 backdrop-blur-md border border-[#d4a843]/20 p-6 rounded-xl hover:border-[#d4a843]/60 transition-all duration-300 group" data-id="element-161">
          <div className="w-12 h-12 rounded-lg bg-[#0a1628] flex items-center justify-center mb-4 border border-[#d4a843]/30 group-hover:border-[#d4a843] transition-colors" data-id="element-162">
            <niche.icon className="w-6 h-6 text-[#d4a843]" data-id="element-163" />
          </div>
          <h3 className="text-xl font-bold text-white mb-2 font-serif" data-id="element-164">
            {niche.title}
          </h3>
          <p className="text-gray-400 text-sm leading-relaxed" data-id="element-165">
            {niche.description}
          </p>
        </motion.div>)}
    </div>;
}